import { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const response = await fetch("/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setStatus("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("Something went wrong.");
      }
    } catch (error) {
      setStatus("Server error.");
    }
  };

  return (
    <section className="contact-modern">
      <div className="contact-wrapper">

        <div className="contact-left">
          <h1>Let's Work Together</h1>
          <p>
            Professional ventilation solutions for industrial and residential projects.
            Contact us today for a free consultation.
          </p>

          <div className="info-box">
            <div className="info-item">
              <span>📞</span>
              <div>
                <h4>Phone</h4>
                <p>+389 75 337 978</p>
              </div>
            </div>

            <div className="info-item">
              <span>📧</span>
              <div>
                <h4>Email</h4>
                <p>furkanzendeli123@outlook.com</p>
              </div>
            </div>

            <div className="info-item">
              <span>📍</span>
              <div>
                <h4>Address</h4>
                <p>Skopje, North Macedonia</p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-right">
          <form onSubmit={handleSubmit}>
            <h2>Send Message</h2>

            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              placeholder="Write your message..."
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>

            <button type="submit">Send Message</button>

            {status && <p className="status-modern">{status}</p>}
          </form>
        </div>

      </div>
    </section>
  );
}

export default Contact;
